var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40918 5.39921C9.99251 5.72525 9.99251 6.54037 9.40918 6.86642L1.53418 11.2681C0.950846 11.5941 0.22168 11.1865 0.22168 10.5345L0.22168 1.73117C0.22168 1.07908 0.950847 0.671518 1.53418 0.997566L9.40918 5.39921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySvg);
export default __webpack_public_path__ + "static/media/playSvg.3988930c4e6e563b5779cf51c0a85265.svg";
export { ForwardRef as ReactComponent };